import { SearchFilterType } from '@/core/search/contexts/search-context';

export enum SearchFilterTypeToUrl {
  genre = '/pinned-series',
  event = '/calendar/event',
  article = '/article',
  bullet = '/article',
}

// PDFs have no widget URL: callers must not build one for them.
export function getSearchFilterTypeUrl(type: Exclude<SearchFilterType, 'pdf'>): string {
  return SearchFilterTypeToUrl[type];
}

export function getItemTypeAndIdFromUri(uri: string) {
  const match = uri.match(/^([^:]+):(.*)$/);
  let itemType: SearchFilterType | null = null;
  let itemId = '';
  if (match) {
    itemType = match[1] as SearchFilterType;
    itemId = match[2];
  }
  return { itemType, itemId };
}
